import React from 'react';
import Header from '../components/Header';

const Merch = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Header />
      <style jsx>{`
        :root{
          --ink:#0b0d11;
          --bg:#0b0d11;
          --fg:#ffffff;
          --accent:#ff7a00;
          --accent2:#0ea5ff;
        }
        *{box-sizing:border-box}
        html,body{margin:0;padding:0;background:var(--bg);color:var(--fg);
          font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;}
        
        /* Make header visible on dark background */
        header {
          background: rgba(11,13,17,.95) !important;
          backdrop-filter: blur(8px);
          border-bottom: 1px solid rgba(255,255,255,.2);
        }
        header * {
          color: #fff !important;
        }
        header a {
          color: #fff !important;
        }
        header button {
          color: #fff !important;
        }
        
        /* Fix mobile menu visibility */
        .lg\\:hidden {
          background: rgba(11,13,17,.95) !important;
          border-color: rgba(255,255,255,.2) !important;
        }
        .lg\\:hidden * {
          color: #fff !important;
        }
        .lg\\:hidden a {
          color: #fff !important;
        }
        .lg\\:hidden button {
          color: #fff !important;
        }
        .lg\\:hidden .text-gray-700,
        .lg\\:hidden .text-gray-900,
        .lg\\:hidden .text-gray-600,
        .lg\\:hidden .text-gray-500 {
          color: #fff !important;
        }
        .lg\\:hidden .bg-white {
          background: rgba(255,255,255,.1) !important;
        }
        .lg\\:hidden .bg-gray-50 {
          background: rgba(255,255,255,.1) !important;
        }
        .lg\\:hidden .border-gray-200 {
          border-color: rgba(255,255,255,.2) !important;
        }
        
        /* Force Quick Book button colors with universal targeting */
        .lg\\:hidden [href*="stubhub"],
        .lg\\:hidden [href*="StubHub"],
        .lg\\:hidden a:first-child {
          background: #1da1f2 !important; /* StubHub - Twitter blue */
          color: #fff !important;
        }
        .lg\\:hidden [href*="ticketmaster"],
        .lg\\:hidden [href*="Ticketmaster"],
        .lg\\:hidden a:nth-child(2) {
          background: #00b388 !important; /* Ticketmaster - green */
          color: #fff !important;
        }
        .lg\\:hidden [href*="expedia"],
        .lg\\:hidden [href*="Expedia"],
        .lg\\:hidden a:nth-child(3) {
          background: #ff7a00 !important; /* Expedia - orange */
          color: #fff !important;
        }
        .lg\\:hidden [href*="vrbo"],
        .lg\\:hidden [href*="VRBO"],
        .lg\\:hidden a:nth-child(4) {
          background: #e74c3c !important; /* VRBO - red */
          color: #fff !important;
        }
        
        /* Remove colored backgrounds from navigation links */
        .lg\\:hidden a[href="/"],
        .lg\\:hidden a[href="/tailgate-central"],
        .lg\\:hidden a[href="/playlists"],
        .lg\\:hidden a[href="/merch"],
        .lg\\:hidden a[href="/about"] {
          background: transparent !important;
          color: #fff !important;
        }
        
        /* Navigation links hover - no background change, just text color */
        .lg\\:hidden a:hover:not([href*="stubhub"]):not([href*="ticketmaster"]):not([href*="expedia"]):not([href*="vrbo"]):not([href*="StubHub"]):not([href*="Ticketmaster"]):not([href*="Expedia"]):not([href*="VRBO"]) {
          background: transparent !important;
          color: #ff7a00 !important;
          transition: all 0.2s ease;
        }
        .lg\\:hidden button:hover {
          background: #fff !important;
          color: #0b0d11 !important;
          transition: all 0.2s ease;
        }
        
        /* Remove universal hover - it's causing the whole section to light up */
        
        /* Override Quick Book button hover effects - ensure text color inverts */
        .lg\\:hidden [href*="stubhub"]:hover,
        .lg\\:hidden [href*="StubHub"]:hover,
        .lg\\:hidden a:first-child:hover {
          background: #fff !important;
          color: #1da1f2 !important;
        }
        .lg\\:hidden [href*="stubhub"]:hover *,
        .lg\\:hidden [href*="StubHub"]:hover *,
        .lg\\:hidden a:first-child:hover * {
          color: #1da1f2 !important;
        }
        .lg\\:hidden [href*="ticketmaster"]:hover,
        .lg\\:hidden [href*="Ticketmaster"]:hover,
        .lg\\:hidden a:nth-child(2):hover {
          background: #fff !important;
          color: #00b388 !important;
        }
        .lg\\:hidden [href*="ticketmaster"]:hover *,
        .lg\\:hidden [href*="Ticketmaster"]:hover *,
        .lg\\:hidden a:nth-child(2):hover * {
          color: #00b388 !important;
        }
        .lg\\:hidden [href*="expedia"]:hover,
        .lg\\:hidden [href*="Expedia"]:hover,
        .lg\\:hidden a:nth-child(3):hover {
          background: #fff !important;
          color: #ff7a00 !important;
        }
        .lg\\:hidden [href*="expedia"]:hover *,
        .lg\\:hidden [href*="Expedia"]:hover *,
        .lg\\:hidden a:nth-child(3):hover * {
          color: #ff7a00 !important;
        }
        .lg\\:hidden [href*="vrbo"]:hover,
        .lg\\:hidden [href*="VRBO"]:hover,
        .lg\\:hidden a:nth-child(4):hover {
          background: #fff !important;
          color: #e74c3c !important;
        }
        .lg\\:hidden [href*="vrbo"]:hover *,
        .lg\\:hidden [href*="VRBO"]:hover *,
        .lg\\:hidden a:nth-child(4):hover * {
          color: #e74c3c !important;
        }
        .hero{
          min-height:100svh;
          display:flex;
          flex-direction:column;
          align-items:center;
          justify-content:flex-start;
          text-align:center;
          position:relative;
          overflow:hidden;
          padding:12vh 24px 24px;
          color:#fff;
          background:
            radial-gradient(1000px 700px at 10% -10%, rgba(255,122,0,.35), rgba(255,122,0,0) 60%),
            radial-gradient(1000px 700px at 90% 0%, rgba(14,165,255,.35), rgba(14,165,255,0) 60%),
            linear-gradient(180deg, #0b0d11, #0b0d11);
        }
        .hero::before{
          content:"";position:absolute;inset:-10% -10%;pointer-events:none;
          background:repeating-linear-gradient(90deg,rgba(255,255,255,.08),rgba(255,255,255,.08) 2px,transparent 2px,transparent 56px);
          transform:skewY(-6deg);
        }
        .banner{
          font-size:clamp(28px, 6vw, 72px);
          font-weight:900;
          letter-spacing:1px;
          margin-bottom:20px;
          background:linear-gradient(90deg,var(--accent),var(--accent2));
          -webkit-background-clip:text;
          -webkit-text-fill-color:transparent;
          animation:bounce 2.5s ease-in-out infinite alternate;
        }
        @keyframes bounce{to{transform:translateY(-12px)}}
        h1{font-size:clamp(36px,9vw,88px);line-height:1.03;margin:0 0 10px;text-shadow:0 8px 30px rgba(0,0,0,.4)}
        .lead{font-size:clamp(16px,3.5vw,22px);opacity:.92;margin:0 0 18px}
        .signup{display:flex;justify-content:center;margin-top:14px}
        .submit{background:linear-gradient(135deg,var(--accent),var(--accent2));border:0;color:#101114;font-weight:900;
          padding:14px 32px;border-radius:14px;cursor:pointer;width:100%;max-width:300px}
        footer{padding:18px;color:#cfd6ea;text-align:center}
      `}</style>
      
      <section className="hero" aria-label="Merch Coming Soon">
        <div className="banner">MERCH COMING SOON</div>
        <div className="wrap">
          <h1>Your GameDay Merch Starts Here</h1>
          <p className="lead">Connect with fans, gear up for epic trips, and get first access to the Forty Bags drop.</p>
          {/* <div className="signup">
            <button className="submit" type="button">Tap for Merch</button>
          </div> */}
        </div>
      </section>

    </div>
  );
};

export default Merch;